<template>
  <Head>
    <title>Ingredients | NutriStudents K-12</title>
    <meta name="description" content="Ingredients">
  </Head>
  <default-layout>
    <BreadcrumLayout>
      <!-- <a href="#" class="link-color"> --><U>Templates</U><!-- </a> -->
    </BreadcrumLayout>
    <PageTitleLayout>
      <div class="lg:mb-0 mb-4">
        <h1 class="heading-color xl:text-4xl text-2xl font-bold">Ingredients</h1>
      </div>

      <div class="w-full flex lg:flex-nowrap flex-wrap justify-end items-center">
        <a :href="route('download-exception-report', 'ingredients') + '?user=' + menuUserFilterVal + '&search=' + search"
          title="Exception Ingredient Report" class="flex items-center icon-color mr-3" target="_blank">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
            class="w-8 h-8">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
          </svg></a>

        <a href="javascript:void(0)" @click="clearFilter" class="flex items-center "><img
            :src="$page.props.asset_url + '/images/clear-filter.png'" class="max-h-6"></a>

        <div class="relative lg:pl-6 sm:pl-6 pl-0 lg:w-48 sm:w-1/2 w-full lg:top-0 sm:top-0 top-4 mr-5">
          <!-- <select id="menuUserFilter" name="menuUserFilter" autocomplete=""
            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height"
            @change="allFilter" v-model="menuUserFilterVal">
            <option value="">Source</option>
            <option v-for="menu_user in tenant_names" :value="menu_user['id']">{{ menu_user['name'] }}</option>
          </select> -->
          <div class="relative w-auto" v-click-outside="onClickOutside">
              <div class="relative inline-block w-full sm:text-sm normal-case">
                  <button
                  v-on:click="showSourceDropDwon = !showSourceDropDwon"
                      type="button"
                      class="bg-white border border-gray-300 h-[38px] w-full text-left rounded-lg pr-10 pl-3"
                  >
                  Source
                  </button>
                  <ul v-if="showSourceDropDwon"
                      class="dropdown-menu min-w-[200px] absolute z-10 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-[250px] overflow-auto">
                      <li v-for="menu_user in tenant_names" :key="menu_user.id" class="px-4 py-2 hover:bg-gray-100 list_bg">
                          <label :for="menu_user.id" class="flex items-center cursor-pointer">
                              <input v-on:click=""
                              :value="menu_user.id"
                              :id="menu_user.id"
                              @change="allFilter"
                              v-model="menuUserFilterVal"
                              type="checkbox"
                              class="text-blue-600 focus:outline-none focus:ring-0 focus:shadow-none form-checkbox parent-checkbox"
                              data-group=""
                              />
                              <span class="ml-2">{{ menu_user.name }}</span>
                          </label>
                      </li>
                  </ul>
              </div>
          </div>
          <div
            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
            <i class="fa fa-sort-desc" aria-hidden="true"></i>
          </div>
        </div>

        <div v-if="!$page.props.is_master_tenant"
          class="relative lg:pl-6 sm:pl-6 pl-0 lg:w-48 sm:w-1/2 w-full lg:top-0 sm:top-0 top-4 mr-5">
          <select id="is_source_updated" name="is_source_updated" autocomplete=""
            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height"
            @change="allFilter" v-model="is_source_updated">
            <option value="">Source Modified</option>
            <option value="yes">Yes</option>
            <option value="no">No</option>
          </select>
          <div
            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
            <i class="fa fa-sort-desc" aria-hidden="true"></i>
          </div>
        </div>
        <!-- <div class="relative focus:outline-none lg:w-44 sm:w-1/2 w-full">
          <select id="component" name="component" autocomplete="component" class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height" @change="onChangeComponentfunc" v-model="componentval">            
            <option value="">Component</option>
            <option v-for="component in components" :value="component.id">{{component.name}}</option>
          </select>
          <div
            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none"
          >
            <i class="fa fa-sort-desc" aria-hidden="true"></i>
          </div>
        </div>
        <div class="relative lg:pl-6 sm:pl-6 pl-0 lg:w-48 sm:w-1/2 w-full lg:top-0 sm:top-0 top-4">
          <select id="sub_component" name="sub_component" autocomplete="sub_component"
            class="shadow-sm focus:border-color block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height" @change="onChangeSubComponentfunc" v-model="subcomponentval">
            <option v-for="subcomponent in subcomponents" :value="subcomponent.id">{{subcomponent.name}}</option>
          </select>
          <div
            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none"
          >
            <i class="fa fa-sort-desc" aria-hidden="true"></i>
          </div>
        </div> -->
        <button>
          <inertia-link :href="route('ingredients-add')"
            class="button-color text-white font-bold py-3 xl:px-4 px-2 lg:ml-6 sm:ml-6 ml-6 rounded lg:mt-0 sm:mt-4 mt-10 inline-block">
            CREATE NEW INGREDIENT
          </inertia-link>
        </button>
      </div>
    </PageTitleLayout>
    <TableFilterLayout @messageFromChild="ingredientSearchData" :searchVal="ing_searched" />
    <TableIndexLayout>
      <div class="-my-2">
        <div class="py-2 align-middle inline-block xl:px-10 px-5 w-full">
          <div class="shadow overflow-x-auto max-height-screen">
            <table class="min-w-full">
              <thead class="header-bg-color">
                <tr>

                  <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                    INGREDIENT
                  </th>
                  <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                    Source
                  </th>
                  <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                    PREFERRED PRODUCT
                  </th>
                  <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                    CATEGORY
                  </th>
                  <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                    SUB CATEGORY
                  </th>
                  <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">

                  </th>
                </tr>
              </thead>
              <tbody>

                <!-- Oddd row -->
                <tr v-if="!ingredients.data.length" class="bg-white">
                  <td class="px-6 py-4 whitespace-nowrap text-base text-color text-center" colspan="7">No Ingredients
                    Found</td>
                </tr>

                <tr v-for="(ingredient, index) in ingredients.data"
                  :class="{ 'bg-white': index % 2 == 0, 'tr-background-color': index % 2 != 0 }">

                  <td
                    class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color underline id-color font-bold ">
                    <div class="tooltip">
                      <div class="trim_text underline"><a :href="route('ingredients-edit', { id: ingredient.id })">{{
                        ingredient.name }}</a></div>
                      <div class="top">
                        {{ ingredient.name }}
                        <i></i>
                      </div>
                    </div>
                  </td>

                  <td class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color">
                    {{ ingredient.tenant_name }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color">
                    {{ ingredient.prod_name }}
                  </td>

                  <td class="px-6 py-4 whitespace-nowrap text-base text-color">
                    {{ ingredient.prod_category }}
                  </td>

                  <td class="px-6 py-4 whitespace-nowrap text-base font-medium text-color">
                    {{ ingredient.prod_sub_category }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap  id-color text-xl  font-extrabold">
                    <button type="button" @click="ingredient_copy_save_script(ingredient.id)" class="">
                      <i class="fa fa-clone pr-3" aria-hidden="true"></i>
                    </button>

                    <inertia-link :href="route('ingredients-edit', { id: ingredient.id })" class="">
                      <i class="fa fa-pencil-square-o pr-3" aria-hidden="true"></i>
                    </inertia-link>

                    <button v-if="ingredient.is_tenant_admin" type="button"
                      @click="ingredient_delete_script(ingredient.id)" class="">
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>
                  </td>
                </tr>


              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="float-left w-full flex justify-start px-10">
        <paginate :urlsArray="links"></paginate>
      </div>

      <div class="mt-12 flex justify-end pr-10 w-full mb-8">
        <button><inertia-link :href="route('ingredients-add')"
            class="button-color text-white font-bold py-1.5 px-4 mb- rounded focus:outline-none inline-block">
            CREATE NEW INGREDIENT
          </inertia-link>
        </button>
      </div>
    </TableIndexLayout>
  </default-layout>
</template>
<script>
import vClickOutside from "click-outside-vue3";
import DefaultLayout from "@/Layouts/DefaultLayout";
import Welcome from "@/Jetstream/Welcome";
import BreadcrumLayout from "@/Pages/Common/Breadcrumbs";
import PageTitleLayout from "@/Pages/Common/PageTitle";
import TableFilterLayout from "@/Pages/Common/TableFilters";
import TableIndexLayout from "@/Pages/Common/TableIndex";
import Paginate from "@/Pages/Partials/Paginate";

export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: ['ingredient_data', 'ing_searched', 'ing_source', 'tenant_names', 'is_source_update'],
  components: {
    vClickOutside,
    DefaultLayout,
    Welcome,
    BreadcrumLayout,
    PageTitleLayout,
    TableFilterLayout,
    TableIndexLayout,
    Paginate,
  },


  data() {
    return {
      componentval: "",
      subcomponentval: "",
      search: this.ing_searched,
      showSourceDropDwon: false,
      menuUserFilterVal: this.ing_source || [],
      subcomponents: [{ id: '', name: 'Sub Component' }],
      ingredients: this.ingredient_data,
      links: this.ingredient_data.links,
      is_source_updated: this.is_source_update,
      form: this.$inertia.form({

      })
    }
  },



  methods: {


    ingredient_copy_save_script(id) {
      if (confirm("Are you sure you want to duplicate this ingredient?")) {
        this.form.post(this.route('ingredient-copy', id), {
          onSuccess: () => {
            this.$toast.success('Ingredient copied successfully!');
            // setTimeout(function(){
            //   window.location.reload();
            // }, 1000);
          }
        });
      }
    },

    ingredient_delete_script(id) {
      if (confirm("Are you sure you want to delete this ingredient?")) {
        this.form.post(this.route('ingredient-delete', id), {
          onSuccess: () => {
            this.$toast.success('Ingredient deleted successfully!');
            setTimeout(function () {
              window.location.reload();
            }, 1000);
          }
        });
      }
    },
    allFilter() {
      let $this = this;
      axios.post('/ingredient-search-filter', { search: this.search, source: this.menuUserFilterVal, is_source_updated: this.is_source_updated, routeName: this.$page.props.route_info_name })
        .then((response) => {
          this.ingredients = response.data;
          this.links = this.ingredients.links;
          this.links.map(function (item, i) {
            if (item.url) {
              let new_url = item.url.split('?');
              let main_url = window.location.href.split('?')[0];
              item.url = main_url + '?' + new_url[1] + '&search=' + $this.search + '&source=' + $this.menuUserFilterVal + '&is_source_updated=' + $this.is_source_updated;
              return item;
            }
          });
        })
        .catch(error => console.error(error));
    },
    clearFilter() {
      this.menuUserFilterVal = [];
      this.is_source_updated = '';
      this.allFilter();
    },


    ingredientSearchData(search) {
      this.search = search;
      this.allFilter();

      // if(search == ""){
      //    this.ingredients = this.ingredient_data;
      //    this.links = this.ingredient_data.links;
      // // this.$toast.error('Error: Search value required!');
      // // return false;
      // }else{
      // axios.post('/ingredient-search-filter',{type:'search',term:search})
      //         .then((response)=>{
      //            this.ingredients = response.data;
      //            this.links = this.ingredients.links;
      //            this.links.map(function(item, i){
      //                if(item.url){
      //                       let new_url = item.url.split('?');
      //                       let main_url = window.location.href.split('?')[0];
      //                       item.url = main_url +'?' +new_url[1] +'&search=' +search;
      //                       return item;
      //                     }
      //            });

      //          })
      //         .catch(error => console.error(error));
      // }
    },

    onChangeComponentfunc() {

      if (this.componentval == "") {

        window.location.reload();

      } else {

        axios.post('/get_subcomponents', { component_id: this.componentval })
          .then((response) => {
            this.subcomponents = [];
            this.subcomponents = response.data;
          })
          .catch(error => console.error(error));

        axios.post('/ingredient-search-filter', { type: 'filter', term: this.componentval })
          .then((response) => {
            this.ingredients = response.data;
          })
          .catch(error => console.error(error));
      }

    },


    onChangeSubComponentfunc() {

      axios.post('/ingredient-search-filter', { type: 'filter', term: this.subcomponentval })
        .then((response) => {
          this.ingredients = response.data;
        })
        .catch(error => console.error(error));
    },
    onClickOutside(event) {
      this.showSourceDropDwon = false;
    },



  },



};
</script>

<style>
@media screen and (min-width: 1500px) {
  .id_arrow .fa-sort-desc:before {
    content: "\f0dd";
    position: absolute;
    top: 16px;
    left: 43px;
    padding-left: 7px;
    color: #219FD5;
  }

  .id_arrow .fa-sort-asc:before {
    content: "\f0de";
    color: #219FD5;
    padding-left: 7px;
    position: absolute;
    top: 16px;
    left: 43px;
  }
}

@media screen and (max-width: 1499px) {
  .id_arrow .fa-sort-asc:before {
    content: "\f0de";
    color: #219FD5;
    padding-left: 7px;
    position: absolute;
    top: 28px;
    left: 43px;
  }

  .id_arrow .fa-sort-desc:before {
    content: "\f0dd";
    position: absolute;
    top: 28px;
    left: 43px;
    padding-left: 7px;
    color: #219FD5;
  }

}


.max-height-screen {
  max-height: calc(100vh - 380px);
}

.trim_text {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 250px;
}

.tooltip {
  display: inline-block;
  position: relative;
  text-align: left;
}

.tooltip .top {
  width: 250px;
  top: 50%;
  left: 100%;
  margin-left: 20px;
  transform: translate(0, -50%);
  padding: 5px 10px;
  color: #444444;
  background-color: #EEEEEE;
  font-weight: normal;
  font-size: 14px;
  border-radius: 5px;
  position: absolute;
  z-index: 99999999;
  box-sizing: border-box;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
  display: none;
  white-space: normal;
}

.tooltip:hover .top {
  display: block;
}

.tooltip .top i {
  position: absolute;
  top: 50%;
  right: 100%;
  margin-top: -12px;
  width: 12px;
  height: 24px;
  overflow: hidden;
}

.tooltip .top i::after {
  content: '';
  position: absolute;
  width: 12px;
  height: 12px;
  left: 0;
  top: 50%;
  transform: translate(50%, -50%) rotate(-45deg);
  background-color: #EEEEEE;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
}
</style>
